module.exports = __webpack_public_path__ + "static/media/level03.97bfc7ca.svg";